<div id="login" fxLayout="column">

    <div id="login-form-wrapper" fxLayout="column" fxLayoutAlign="center center">

        <div id="login-form" [@animate]="{value:'*',params:{duration:'300ms',y:'100px'}}">

            <div id="login-form-content">
                <div class="title">AKILLI-ATIK-SİSTEMİ </div>
    
                <form>
    
                    <mat-form-field appearance="outline">
                        <mat-label>Username</mat-label>
                        <input name="user" required [(ngModel)]="model.username" matInput>
                        <mat-icon matSuffix class="secondary-text">account_circle</mat-icon>
                        <mat-error>
                            Username is required
                        </mat-error>
                    </mat-form-field>
    
                    <mat-form-field appearance="outline">
                        <mat-label>Password</mat-label>
                        <input name="pass" required [(ngModel)]="model.password" matInput type="password">
                        <mat-icon matSuffix class="secondary-text">vpn_key</mat-icon>
                        <mat-error>
                            Password is required
                        </mat-error>
                    </mat-form-field>
    
    
                    <button mat-raised-button color="accent" (click)="login()" class="submit-button" aria-label="LOG IN">
                        LOGIN
                    </button>
    
                </form>
            </div>
            <mat-progress-bar [fxShow]="tableLoading"  style="border-radius: 10px;" mode="indeterminate"></mat-progress-bar>
        </div>

    </div>

</div>